import React from "react";
import { Box, Typography, Container, Grid2 } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FamilyPic from "../assets/Fam_pic.jpg";
const historyData = [
  {
    year: 1998,
    event: "The foundation of Praise Revival Church was laid in Nallampalli with a vision to bring the light of Christ to the local community.",
  },
  {
    year: 2002,
    event: "The church moved to Dharmapuri town, opening its doors to more believers and expanding its outreach.",
  },
  {
    year: 2015,
    event: "Praise Revival Church was officially established as a trust, empowering us to serve with greater commitment and reach more lives with the Gospel.",
  },
];

const AboutHistory = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6, backgroundColor: "background.default" }}>
      <Container>
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "primary.main",
            animation: `${theme.keyframes.fadeInUp} 1.5s`,
          }}
        >
          Our History
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontSize: "1.25rem",
            lineHeight: 1.8,
            color: "text.secondary",
            textAlign: "center",
            animation: `${theme.keyframes.fadeInUp} 2s`,
          }}
        >
          From Humble Beginnings to a Thriving Community
        </Typography>

        {/* Image Section */}
        <Grid2 xs={12} md={6} display="flex" justifyContent="center" alignItems="center" container spacing={4} sx={{ py: 6, mt: 4 }} minHeight={"500px"} minWidth={"300px"}>
          <Box
            component="img"
            src={FamilyPic}
            alt="Church Image"
            sx={{
              width: "100%",
              borderRadius: 2,
              boxShadow: 3,
              animation: `${theme.keyframes.zoomIn} 2s`,
            }}
          />
        </Grid2>

        <Grid2 display="flex" justifyContent="center" alignItems="center" minHeight="100vh" container spacing={4} sx={{ py: 6, mt: 4 }}>
          {historyData.map((item, index) => (
            <Grid2
              xs={12}
              md={4}
              key={index}
              sx={{
                animation: `${theme.keyframes.fadeIn} 2s`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  p: 3,
                  backgroundColor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 3,
                  textAlign: "center",
                  animation: `${theme.keyframes.zoomIn} 2s`,
                  height: { xs: "auto", sm: "250px", lg: "250px" }, // Responsive height
                  width: { xs: "100%", sm: "90%", lg: "100%" }, // Responsive width
                  maxWidth: "800px", // Max width for large screens
                  display: "flex",
                  flexDirection: "column", // Stack year and event vertically
                  justifyContent: "center", // Center content vertically
                }}
              >
                <Typography variant="h6" color="primary" sx={{ fontWeight: "bold" }}>
                  {item.year}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2, fontSize: "1rem", color: "text.primary" }}>
                  {item.event}
                </Typography>
              </Box>
            </Grid2>
          ))}
        </Grid2>

        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography variant="body1" sx={{ fontSize: "1.2rem", lineHeight: 1.8, color: "text.secondary" }}>
            Our journey has been one of faith, perseverance, and abundant blessings, and we continue to walk in obedience to God’s calling.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutHistory;
